import { useCallback } from 'react';
import { noop } from 'utils/fp';
import { useModalActions } from 'components/ModalManager/Context';
import { cx } from '@linaria/core';
import { cssHelpers } from 'styles/utils/core';
import { IModelPredictionStoreMST } from 'modules/Predictions/mst/ModelPredictionStore';
import { IWorkflowPredictionStoreMST } from 'modules/Predictions/mst/WorkflowPredictionStore';
import { PresetInputsUploader } from './PresetInputsUploader';
export function usePresetInputsUploader(editableEntity: CF.UI.EditableEntity, inputType: CF.API.InputType, store: IModelPredictionStoreMST | IWorkflowPredictionStoreMST): () => void {
  const {
    openModal,
    closeModal
  } = useModalActions();
  const close = useCallback(() => closeModal({
    id: 'upload_model_metadata_inputs'
  }), [closeModal]);
  return useCallback(() => {
    openModal({
      id: 'upload_model_metadata_inputs',
      title: 'Public Preview Examples',
      content: <div className={cx(cssHelpers.margin.y[0], cssHelpers.margin.x[2])}>
          <PresetInputsUploader store={store} editableEntity={editableEntity} closeModal={close} inputType={inputType} />
        </div>,
      makeActions: noop
    });
  }, [openModal]);
}